<template>
<div class="equipment-tree-container">
    <el-tree
    :data="data"
    node-key="id"
    default-expand-all
  >
    <span class="custom-tree-node" slot-scope="{ data }">
      <span>{{ data.type }}</span>-<span>{{ data.loopName }}</span>
      <!-- <span>{{ node.label }}</span> -->
      <span><span></span></span>
      <span>{{ data.breakerName }}</span>
    </span>
  </el-tree>
</div>
</template>

<script>
export default {
  props: {
    data: Array,
  },
};
</script>


<style lang="less" scoped>
.custom-tree-node {
    display: flex;
    width: 100%;
    justify-content: space-between;

    :nth-child(1) {
        font-size: 18rem;
        font-weight: 400;
        color: #0D94FF;
    }

    :nth-child(2) {
        font-size: 18rem;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
    }

    :nth-child(3) {
        flex: 1;
        padding-left: 19rem;
        padding-right: 25rem;
        display: flex;
        align-items: center;

        span {
            width: 100%;
            height: 1px;
            background-image: linear-gradient(
                to right,
                rgba(153, 153, 153, 1) 0%,
                rgba(153, 153, 153, 1) 50%,
                transparent 10%
            ) !important;
            background-size: 30px 1px !important;
            background-repeat: repeat-x !important;
        }
    }

    :nth-child(4) {
        font-size: 18rem;
        font-weight: 400;
        color: #666666;
    }
}
</style>